import { CompanionProfile, getCompanionDisplayName, isPresetCompanion } from '@/lib/useCompanions';
import styles from './index.module.less';

function getInitial(name: string) {
  const trimmed = name.trim();
  return trimmed ? trimmed.slice(0, 1).toUpperCase() : '+';
}

export default function CompanionDock(props: {
  visible: boolean;
  layout: 'arc' | 'vertical';
  profiles: CompanionProfile[];
  activeId?: string;
  canAddMore: boolean;
  emptyText: string;
  showEmptyCard?: boolean;
  /** Compact arc: drop the tall reserved band so the row hugs its avatars.
   *  Used inside the mobile top-rail tray where vertical space is precious. */
  dense?: boolean;
  onSelect: (id: string) => void;
  onAdd: () => void;
  onDelete: (id: string) => void;
}) {
  const { visible, layout, profiles, activeId, canAddMore, emptyText, onSelect, onAdd, onDelete } =
    props;
  const showEmptyCard = props.showEmptyCard ?? true;
  const items = canAddMore
    ? [
        ...profiles,
        {
          id: '__add__',
          kind: 'custom' as const,
          name: '',
          avatar: '',
          background: '',
          personality: '',
          userCallName: '',
          createdAt: 0,
          updatedAt: 0,
        },
      ]
    : profiles;

  return (
    <div
      className={`${styles.dock} ${styles[layout]} ${props.dense ? styles.dense : ''} ${
        visible ? styles.visible : ''
      }`}
    >
      {!profiles.length && showEmptyCard ? (
        <div className={styles.emptyCard}>
          <div className={styles.emptyText}>{emptyText}</div>
          <button className={styles.emptyAction} type="button" onClick={onAdd}>
            创建伙伴
          </button>
        </div>
      ) : null}
      <div className={styles.items}>
        {items.map((item) => {
          const isAdd = item.id === '__add__';
          const isActive = item.id === activeId;
          // Preset companions (e.g. the built-in Hiyori) are code-defined and
          // cannot be deleted, so never show their delete affordance.
          const canDelete = !isAdd && !isPresetCompanion(item);
          const displayName = isAdd ? '添加伙伴' : getCompanionDisplayName(item);
          return (
            <div
              key={item.id}
              className={`${styles.itemWrap} ${!visible ? styles.itemWrapHidden : ''} ${
                isActive ? styles.itemWrapActive : ''
              }`}
            >
              <button
                type="button"
                className={`${styles.itemButton} ${isActive ? styles.active : ''} ${
                  isAdd ? styles.addButton : ''
                }`}
                onClick={() => {
                  if (isAdd) onAdd();
                  else onSelect(item.id);
                }}
              >
                {item.avatar && !isAdd ? (
                  <img src={item.avatar} alt={displayName} className={styles.avatar} />
                ) : (
                  <span className={styles.avatarFallback}>
                    {isAdd ? '+' : getInitial(displayName)}
                  </span>
                )}
              </button>
              {canDelete ? (
                <button
                  type="button"
                  className={styles.deleteBtn}
                  aria-label={`删除${displayName}`}
                  onClick={(event) => {
                    event.stopPropagation();
                    onDelete(item.id);
                  }}
                >
                  ×
                </button>
              ) : null}
              <div className={styles.itemName}>{displayName}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
